export const mainContainerStyle = {
  mainStyle: {
    approveWithChanges: {
      'background-color': '#eee',
      'width': '94%',
      'height': '90%',
      'position': 'absolute',
      'top': '5%',
      'left': '3%',
      'box-shadow': '0px 8px 16px 0px rgba(0, 0, 0, 0.2)'
    },
    scrollable: {
      'height': '95%',
      'margin-top': '2rem',
      'margin-right': '1.1rem',
      'overflow-y': 'auto'
    },
    tableButton: {
      'margin-top': '1rem',
      'text-align': 'center'
    },
    goalsAndDisplayStyle: {
      'background-color': '#eee',
      'width': '70%',
      'height': '65%',
      'max-height': '400px',
      'position': 'absolute',
      'top': '15%',
      'left': '15%',
      'box-shadow': '0px 8px 16px 0px rgba(0, 0, 0, 0.5)'
    },
    rejectOffer: {
      'background-color': '#eee',
      'width': '60%',
      'height': '55%',
      'position': 'absolute',
      'top': '15%',
      'left': '20%',
      'box-shadow': '0px 8px 16px 0px rgba(0, 0, 0, 0.5)'
    },
    zoneScrollable: {
      'margin': '1rem 1rem 0 1rem',
      'overflow-y': 'auto'
    },
    tableZonePriceChangeTitleStyle: {
      'text-align': 'center',
      'padding': '1rem',
      'color': '#05983b',
      'font-size': '1.8rem',
      'font-weight': '2'
    },
    tableZonePriceChangeMinHeight: {
      'min-height': '65%',
      'font-size': '1.3rem'
    },
    confirmationApproveWithChanges: {
      'background-color': '#eee',
      'position': 'absolute',
      'left': '50%',
      'top': '50%',
      'width': '70%',
      'transform': 'translate(-50%, -50%)',
      'box-shadow': '0px 8px 16px 0px rgba(0, 0, 0, 0.2)'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pop-up/mainContainerStyle.js